<template>
  <div class="view">
    <h1 class="ui icon header">
      <i class="cogs icon" />
      Sorry, we're down for maintenance
    </h1>
    <p class="ui header">
      We'll be back
      <span v-if="!inProgress">as soon as possible</span>
      <span v-if="inProgress">in {{duration}}</span>.
    </p>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import moment from 'moment'

  export default {
    name: 'ErrorMaintenance',
    data() {
      const current = Date.now()
      return {
        current,
      }
    },
    computed: {
      ...mapGetters(['config']),
      end() {
        return new Date(this.config.maintenance).getTime() || 0
      },
      inProgress() {
        return this.config.maintenance && (this.current < this.end)
      },
      duration() {
        const current = moment(this.current)
        const end = moment(this.end)
        const duration = moment.duration(end.diff(current))._data
        if (duration.days) {
          return `${duration.days} d`
        }
        if (duration.hours) {
          return `${duration.hours} h ${duration.minutes} m`
        }
        if (duration.minutes) {
          return `${duration.minutes} m ${duration.seconds} s`
        }
        return `${duration.seconds} s`
      },
    },
    watch: {
      inProgress() {
        if (this.inProgress) {
          this.init()
        } else {
          document.location.reload(true)
        }
      },
    },
    methods: {
      init() {
        if (this.current < this.end) {
          this.$options.interval = setInterval(this.update, 1000)
        }
      },
      update() {
        this.current += 1000
        if (this.current > this.end) {
          clearInterval(this.$options.interval)
        }
      },
    },
    created() {
      this.init()
    },
  }
</script>

<style scoped>
  .view { display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; }
</style>
